var React = require('react');

function ArrowLeft2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.03456 21.8002L24.0449 40.4144L22.9551 41.5859L1.45511 21.5859L0.825438 21.0002L1.45511 20.4144L22.9551 0.414442L24.0449 1.58594L4.03456 20.2002L82 20.2002L82 21.8002L4.03456 21.8002Z","fill":"#303030"}));
}

ArrowLeft2.defaultProps = {"width":"82","height":"42","viewBox":"0 0 82 42","fill":"none"};

module.exports = ArrowLeft2;

ArrowLeft2.default = ArrowLeft2;
